import {
  Action,
  getModule,
  Module,
  Mutation,
  VuexModule,
} from 'vuex-module-decorators';
import store from '@/store';
import { ErrorResponse } from '@/utils/response';
import { axios } from '@/utils/axios';

export enum UploadFolderName {
  preCollectionFolder = 'pre-collection',
  blogFolder = 'blog',
  questionBank = 'question-bank/image',
}
export interface ImageUploadParams {
  files: any;
  folderName?: UploadFolderName | null;
}

export interface ImageUploadResponse {
  id: number;
  url: string;
  name: string;
}

export interface ImageUploadInterface {
  response: ImageUploadResponse | null;
  error: ErrorResponse | null;
  imageUpload(params: ImageUploadParams): Promise<void>;
  setResponseToNull(): Promise<void>;
}

@Module({
  namespaced: true,
  dynamic: true,
  name: 'file-upload',
  store,
})
class ImageUploadStore extends VuexModule implements ImageUploadInterface {
  response: ImageUploadResponse | null = null;
  error: ErrorResponse | null = null;

  @Mutation
  setResponse(params: ImageUploadResponse) {
    this.response = params;
  }

  @Mutation
  setError(error: ErrorResponse) {
    this.error = error;
  }

  @Action
  async setResponseToNull(): Promise<void> {
    this.context.commit('setResponse', null);
  }

  @Action
  async imageUpload(params: ImageUploadParams): Promise<void> {
    this.context.commit('setError', '');
    this.context.commit('setResponse', null);

    try {
      const { files, folderName } = params;
      const formData = new FormData();

      files.forEach((file: any) => {
        formData.append('file', file, file.name);
      });

      const headers = {
        'Content-Type': 'multipart/form-data',
      };

      if (folderName) {
        headers['folder-name'] = folderName;
      }

      const { data } = await axios.post('file_upload', formData, {
        headers,
      });
      this.context.commit('setResponse', data);
    } catch (error) {
      this.context.commit('setError', error);
    }
  }
}

export default getModule(ImageUploadStore);
